import React, { useState, useEffect } from "react";
import Select from 'react-select';
import axios from 'axios';
import { dataUser } from "../Helpers/util";
import moment from 'moment';
import { TickList } from "../../Redux/action/tickList";
import { CSVLink } from 'react-csv';
import { toast } from 'react-toastify';
import axiosInstance from "../../utils/axiosInstance";
import $ from "jquery";
const userDataLocal = dataUser();
const UserObj = JSON.parse(userDataLocal);

const SnagFilterExport = () => {
  // const [raisedBy, setRaisedBy] = useState(false);
  const [locationSpoc, setLocationSpoc] = useState([]);
  const [location1, setLocation1] = useState(null);
  const [status, setStatus] = useState('');
  const [raisedStatus, setRaisedStatus] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loadingExport, setLoadingExport] = useState(false); // Changed from null to false
  const [locationError, setLocationError] = useState('')
  const [startError, setStartError] = useState('')
  const [endError, setEndError] = useState('')

  const headers = [
    { label: 'REQUEST NO', key: 'requestId' },
    { label: 'SUBCATEGORY', key: 'subCategory' },
    { label: 'SUBJECT', key: 'Subject' },
    { label: 'DESCRIPTION', key: 'Description' },
    { label: 'LOCATION', key: 'floorName' },
    { label: 'ASSIGNEE', key: 'ticketOwnerName' },
    { label: 'TICKET CREATED', key: 'createdTime' },
    { label: 'TICKET CLOSED', key: 'ticketCloseTime' },
    { label: 'RAISED BY', key: 'contactName' },
    { label: 'TICKET STATUS', key: 'Status' },
    { label: 'RESOLUTION', key: 'resolution' },
  ];


  useEffect(() => {

    const fetchLocations = async () => {
      try {
        let authToken = JSON.parse(localStorage.getItem('headData'));
        const axiosConfig = {
          params: {



            spoc: UserObj.rec_id,



            client: UserObj.company_id

          },
          headers: { Authorization: `${authToken?.spintlyToken}` }
        };
        const response = await axios.get(`${process.env.REACT_APP_API_URL}basic-data/get-centers-by-spoc`, axiosConfig);
        if (response.data.status === "success") {
          setLocationSpoc(response.data.data);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchLocations();
  }, []);


  const handleLocationChange = (selectedOption) => {
    setLocation1(selectedOption);
    // if (selectedOption.value === 'GGN6') {
    //   setRaisedBy(true);
    // }

    if (!selectedOption) {
      setLocationError("Location can't be empty");
    } else {
      setLocationError('');
    }
  };


  const handleStartDate = (e) => {
    setStartDate(e.target.value)
    if (e.target.value) {
      setStartError('');
    }
  }

  const handleEndDate = (e) => {
    setEndDate(e.target.value)
    if (e.target.value) {
      setEndError('');
    }
  }


  const StatusMethod = (param) => {
    setStatus(param.value);
  };



  const ticketStatus = [
    { value: "All", label: "All" },
    { value: "Closed", label: "Closed" },

    { value: "Open", label: "Open" },

  ];



  const handleExport = async (e) => {
    e.preventDefault();
    setLocationError('');
    setStartError('')
    setEndError('')
    let isValid = true;

    if (!location1) {
      setLocationError("Location can't be empty");
      isValid = false;
    }
    if (!startDate) {
      setStartError("Please choose start date");
      isValid = false;
    }
    if (!endDate) {
      setEndError("Please choose end date");
      isValid = false;
    }


    if (isValid) {

      try {
        const location = location1 ? location1.value : (locationSpoc?.[0]?.centercode || '');
        const raisedByValue = raisedStatus
        let raisedByValue1 = status === 'All' ? '' : status
        let newCompanyId = JSON.parse(localStorage.getItem('headData'));
        const requestData = {
          company_id: newCompanyId?.organizationId,
          status: raisedByValue1,
          location: [location],
          startDate: startDate,
          endDate: endDate,
          raisedBy: raisedByValue
        };

        if (raisedStatus === 'me') {
          // requestData.userId = String(UserObj.rec_id);
          requestData.userId = String(56793);
        }


        const response = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/tickets/downloadTickets`, requestData);

        if (response.status === 200) {
          const responseData = response?.data?.data;
          const headers = [
            { label: 'REQUEST NO', key: 'requestId' },
            { label: 'SUBCATEGORY', key: 'subCategory' },
            { label: 'SUBJECT', key: 'Subject' },
            { label: 'DESCRIPTION', key: 'Description' },
            { label: 'LOCATION', key: 'floorName' },
            { label: 'ASSIGNEE', key: 'ticketOwnerName' },
            { label: 'TICKET CREATED', key: 'createdTime' },
            { label: 'TICKET CLOSED', key: 'ticketCloseTime' },
            { label: 'RAISED BY', key: 'contactName' },
            { label: 'TICKET STATUS', key: 'Status' },
            { label: 'RESOLUTION', key: 'resolution' },
          ];

          const csvData1 = [];

          // Add CSV header
          const headerRow = headers.map(header => header.label);
          csvData1.push(headerRow.join(','));

          // Add CSV rows
          responseData.forEach(item => {
            const row = headers.map(header => item[header.key] || '');
            csvData1.push(row.join(','));
          });

          // Convert CSV data to blob
          const csvString = csvData1.join('\n');
          const csvBlob = new Blob([csvString], { type: 'text/csv;charset=utf-8' });

          // Create a URL for the Blob object
          const url = window.URL.createObjectURL(csvBlob);

          // Create a link element to trigger the download
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'tickets.csv');

          // Append the link to the document body and trigger the download
          document.body.appendChild(link);
          link.click();

          // Clean up resources
          window.URL.revokeObjectURL(url);
          setTimeout(() => {
            toast.success('Snag filtered data export successfully', {

            });
          }, 1000)


          $(".close").click();
          setLocation1('')
          setEndDate('')
          setStartDate('')
          setStatus('')
          setRaisedStatus('')
        }
        setLoadingExport(false); // Reset loading state
      } catch (error) {
        console.error('Error exporting data:', error);
        setLoadingExport(false); // Reset loading state in case of error
      }
    }

  };

  const resetValue = () => {
    setLocation1(null);
    setStatus('');
    setRaisedStatus('');
    setStartDate(null);
    setEndDate(null);
  };


  return (
    <>
      <TickList />
      <div className="custome modal right fade" id="myModalTicketExport" data-backdrop="static">
        <div className="modal-dialog custome">
          <div className="modal-content custome">
            <div className="formTitle">
              Export Snags
              <button type="button" className="relateDox close" data-dismiss="modal">
                x
              </button>
            </div>
            <div className="modal-body custome">
              <div className="addmemberformBody">
                <form>
                  <div className="card-body">
                    <div>
                      <div className="row">

                        <div className="col-md-12 ">
                          <div className="formAddmemGrid">
                            <label>Project Name <span className='Required'>*</span></label>
                            <Select
                              value={location1}
                              onChange={handleLocationChange}
                              options={locationSpoc.map(item => ({
                                value: item.centercode,
                                label: item.location_name
                              }))}
                            />
                            <span className="SwTextDanger SwTextSmall">
                              {locationError}
                            </span>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="formAddmemGrid">
                            <label>Location Name*</label>
                            <Select
                              value={location1}
                              onChange={handleLocationChange}
                              options={locationSpoc.map(item => ({
                                value: item.centercode,
                                label: item.location_name
                              }))}
                            />
                            <span className="SwTextDanger SwTextSmall">
                              {locationError}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 col-xl-12 col-lg-12">
                          <div className="formAddmemGrid">
                            <label>Start Date <span className='Required'>*</span></label>
                            <input
                              type="date"
                              name="startDate"
                              className="form-control"
                              value={startDate}
                              onChange={handleStartDate}
                            />
                            <span className="SwTextDanger SwTextSmall">
                              {startError}
                            </span>
                          </div>
                        </div >
                      </div >

                      <div className="row">
                        <div className="col-md-12 col-xl-12 col-lg-12">
                          <div className="formAddmemGrid">
                            <label>End Date <span className='Required'>*</span></label>
                            <input
                              type="date"
                              name="endDate"
                              className="form-control"
                              value={endDate}
                              onChange={handleEndDate}
                            />
                            <span className="SwTextDanger SwTextSmall">
                              {endError}
                            </span>
                          </div>
                        </div >
                      </div >

                      <div className="row">
                        <div className="col-md-12 col-xl-12 col-lg-12">
                          <div className="formAddmemGrid">
                            <label>Status</label>
                            <Select
                              name="status"
                              options={ticketStatus}
                              onChange={StatusMethod}
                            />
                          </div>
                        </div>
                      </div>





                      <div className="addmemberFooter">
                        <div className="pull-right">
                          <button className="btn btn-danger solCancel" type="button" onClick={resetValue}>
                            Reset
                          </button>
                          <button className="btn btn-success addDetails ml10" onClick={handleExport}>
                            Export
                          </button>
                        </div>
                      </div>
                    </div >
                  </div >
                </form >
                {loadingExport}
              </div >
            </div >
          </div >
        </div >
      </div >
    </>
  );
};

export default SnagFilterExport;
